import { useAccount } from 'modules/account/hooks/useAccount';
import { useAppSelector } from 'store/useAppSelector';

import {
  selectHasAccountStatusTransition,
  selectHasFreemiumToPremiumTransition,
} from '../store/selectors';

export const useAccountStatusTransition = () => {
  const { userEndpointToken } = useAccount();

  const hasAccountStatusTransition = useAppSelector(state =>
    selectHasAccountStatusTransition(state, {
      userEndpointToken: userEndpointToken!,
    }),
  );

  const hasFreemiumToPremiumTransition = useAppSelector(state =>
    selectHasFreemiumToPremiumTransition(state, {
      userEndpointToken: userEndpointToken!,
    }),
  );

  return { hasAccountStatusTransition, hasFreemiumToPremiumTransition };
};
